import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import { MasterService,FeecounterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';


@Component({
  selector: 'app-acreceipt',
  templateUrl: './acreceipt.component.html',
  styleUrls: ['./acreceipt.component.scss'],
  providers:[MasterService,FeecounterService,ClassroomService]
})
export class AcreceiptComponent implements OnInit {
  sections:any=[];
  classes:any=[];
  arrstudent:any=[];
  arritem:any=[];
  arrvocdet:any=[];
  attdata:any=[];
  objfsm:any={};
  objinfo:any={};
  arrcat:any=[];
  arrclasscat:any=[];
  colums:any=[]
  fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
  fmodel1:any={clid:'0',secid:'0',accatid:'0',crid:'0'};
  arrrepdata:any=[];
  arrper:any=[];
  arrrechead:any=[];
  arrastype:any=[];
  arracchead:any=[];
  arrcol:any=[];
  accat:any=[];
  arrfeerech:any=[];
  objvhead:any={};
  objfcol:any={};
  objstu:any={};
  oprtype:any='';
  oprtype1:any='';
  tabledata: any = {};
  ttldfeamt=0;
  arrfeesum:any=[];
  showload='No';
  sertxt:any="";
  catid:any;
  clientcd='';
  selmember:any={};
  memberdetails:any=[];
  modalOptions:NgbModalOptions;

  modalOptions1:NgbModalOptions;
  private modalRef: NgbModalRef;
  private modalRef1: NgbModalRef;
  private modalRef2: NgbModalRef;
  objdet: any = {};
  recdetails:any=[];
  objdetacc:any={};
  objfeesh:any={};
  objmisc:any={};
  Modeot:any=[];
  classsort:any=[];
  sum=0;
  mordet = [
    {value: 'Unified Payments', viewValue: 'Unified Payments'},
    {value: 'Debit Card', viewValue: 'Debit Card'},
    {value: 'Credit Card', viewValue: 'Credit Card'},
    {value: 'Net Banking', viewValue: 'Net Banking'}
   
  ];
  rights="";

  order_id:string;
currency: string='INR';
amount: string;
language:string;
redirect_url:string='';//'http://106.51.136.76/Expzpayapi/api/payredirect';//
cancel_url:string='';//'http://106.51.136.76/Expzpayapi/api/payredirect'//'https://plvglobal.com/PHPpayment/ccavResponseHandler.php';
billing_name:string;
billing_country:string= "India";
billing_tel:string;
billing_email:string;
billing_address:string;
billing_city:string;
billing_state:string;
sub_account_id:string='';
payip:any='';

merchant_id:string='244217';
billing_zip:string;
arrcourse:any=[];
@ViewChild('form') form: ElementRef;
@ViewChild('formairpay') formairpay: ElementRef;
@ViewChild('frmpayu') formpayu: ElementRef;
encRequest: String;
accessCode: String;
buyer_Email:string='';
buyer_Phone:any='';
buyer_FirstName:any='';
buyer_LastName:any='';
buyer_Address:any='';
buyer_City:any='';
airorderid:any='';
currency1:any='356';
iso_currency:any='INR';
buyer_State:any='';
buyer_Country:any='INDIA';
buyer_PinCode:any='';
custom_var:any='';
amount1:any='';
  key: any;
  txnid: string;
  productinfo: any;
  firstname: any;
  email: string;
  sltk: any;
  phone: any;
  surl: string;

  constructor(private http: HttpClient,private aservice:FeecounterService,private cservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { 

    this.getpayip();
  }


  
  ngOnInit(): void {
    this.rights=localStorage.getItem('rts');
    this.clientcd=localStorage.getItem('clcd');
    //this.masclass();
    this.fmodel.dtfrm=this.mservice.getdatetoday();
    this.fmodel.dtto=this.mservice.getdatetoday();
    this.getdashoverview();
    this.masmot();
    this.mascourse();
    this.masacccat();

  }

  getpayip()
 {
   this.mservice.getpayipurl()
   .subscribe(
          resultArray =>{
  // this.liservice.Getdashboarddata('dashcounts')
     console.log('result-dashcounts',resultArray) ;
     this.payip=resultArray;
     if(resultArray=="http://43.247.158.89")
     {
      this.accessCode="AVLT16LI65AH45TLHA";
      this.redirect_url='http://43.247.158.89:8082/mycampuz/api/v3/ccavResponseHandler.php';
      this.cancel_url='http://43.247.158.89:8082/mycampuz/api/v3/ccavResponseHandler.php';
     }

     else if(resultArray=="http://106.51.141.70")
     {
      this.accessCode="AVLT16LI65AH44TLHA";
      this.redirect_url='http://106.51.141.70:8082/mycampuz/api/v3/ccavResponseHandler.php';
      this.cancel_url='http://106.51.141.70:8082/mycampuz/api/v3/ccavResponseHandler.php';
     }
     //this.getprofiledata();

     },
    error => console.log('Error :: ' + error)
 );
 }

paymentrequestdata(obj)
  {
    debugger
    
     this.aservice.paymentrequestdata(obj)
    
    //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      
      this.objfeesh = resultArray;
      this.paymentapi();
     // this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
     
      },
     error => console.log("Error :: " + error)
  )
    }


    airpaymentrequestdata(obj)
  {
    debugger
    
     this.aservice.paymentrequestdata(obj)
    
    //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      
      this.objfeesh = resultArray;
      this.airpaymentapi();
     // this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
     
      },
     error => console.log("Error :: " + error)
  )
    }


     payugateway()
    {

     
const currentTimestamp: number = Date.now();
  
   this.key= "BiJQQu";
    this.txnid= 'plv-'+currentTimestamp;
    this.amount= '10.00';
   
    this.productinfo= 'Academic Fees';
    this.firstname= 'Plv student';
    this.email= "test@123.com";
  this.sltk='fgkUdODQGYFt32BAedgHdKi5judGMsMI';
  this.phone='9916438089';
  this.surl="https://mycampuz.co.in/payU/receicepayuresponse.php";
  // this.buyer_Address=this.objfeesh.billingaddress;
  // this.buyer_City=this.objfeesh.billcity;
  // this.buyer_State=this.objfeesh.billcity;
  
  // this.buyer_PinCode=this.objfeesh.billingzip,

  // this.custom_var=this.objfeesh.stuid+"_"+this.objfeesh.insid+"_"+this.objfeesh.deptid+"_"+this.objfeesh.cl_db+"_"+this.objfeesh.recnoh;
  
  
  
  
       
     setTimeout(_ => this.formpayu.nativeElement.submit());
  
 
    }

    airpaymentapi()
    {

     

  
   this.airorderid= this.objfeesh.orderid;
    this.iso_currency= 'INR';
    this.amount1= this.objfcol.recamt;
   
    this.buyer_FirstName= this.objfeesh.billingname;
    this.buyer_LastName= this.objfeesh.billingname;
    this.buyer_Country= "India";
  this.buyer_Phone=this.objfeesh.billtel;
  this.buyer_Email=this.objfeesh.billemail;
  this.buyer_Address=this.objfeesh.billingaddress;
  this.buyer_City=this.objfeesh.billcity;
  this.buyer_State=this.objfeesh.billcity;
  
  this.buyer_PinCode=this.objfeesh.billingzip,

  this.custom_var=this.objfeesh.stuid+"_"+this.objfeesh.insid+"_"+this.objfeesh.deptid+"_"+this.objfeesh.cl_db+"_"+this.objfeesh.recnoh;
  
  
  
  
       
     setTimeout(_ => this.formairpay.nativeElement.submit());
  
 
    }
  
    
  paymentapi()
  {
    //this.accessCode = 'AVMJ77JD33AO90JMOA';
   // this.accessCode='AVDF95HJ89AZ06FDZA';
      //var formdata=this.enqdata;
//     const orderParams = {

//       order_id: '1234',
//       currency: 'INR',
//       amount: '1',
//       language:'EN',
//       redirect_url: this.redirect_url,
//       cancel_url:this.cancel_url,
//       billing_name: 'PLV Testing',
//       billing_country: "India",
//   billing_tel: '9916438089',
//   billing_email:'vinayn143@gmail.com',
//   billing_address:'banagalore',
//   billing_city:'banagalore',
//   billing_state:'Karnataka',

//   merchant_id:'202263',
//   sub_account_id:'MYC009',
//   billing_zip:'560054',
//   merchant_param2: 'MYC2209',
//   merchant_param1:'123456789'


// };
   
const orderParams = {

  order_id: this.objfeesh.orderid,
  currency: 'INR',
  amount: this.objfcol.recamt,
  language:'EN',
  redirect_url: this.redirect_url,
  cancel_url:this.cancel_url,
  billing_name: this.objfeesh.billingname,
  billing_country: "India",
billing_tel:this.objfeesh.billtel,
billing_email:this.objfeesh.billemail,
billing_address:this.objfeesh.billingaddress,
billing_city:this.objfeesh.billcity,
billing_state:this.objfeesh.billcity,

merchant_id:this.objfeesh.merchantid,
sub_account_id:this.objfeesh.submerchantid,
billing_zip:this.objfeesh.billingzip,
merchant_param2: this.objfeesh.cl_db,
merchant_param1:this.objfeesh.stuid+"_"+this.objfeesh.insid+"_"+this.objfeesh.deptid,
merchant_param3: this.objfeesh.recnoh,


};

      console.log('orderParams',JSON.stringify(orderParams));
    this.aservice.payapi(orderParams)
.subscribe((result:any) => {
    this.encRequest = result;
    localStorage.setItem('orderid','1234');
   // localStorage.setItem('enid',this.defId.toString());
    // console.log('enqres',this.encRequest);
   setTimeout(_ => this.form.nativeElement.submit());

}, error => {
  console.log('enqres',error);
  alert('error in connection')}
);

  }

  

 

  masacccat() {
    debugger
    this.mservice.masacccat()
        .subscribe(
        resultArray => {
            console.log('getacccategory', resultArray);
            this.accat = resultArray;
            this.fmodel.accatid=resultArray[0].accatid;
            this.objmisc.accatid=resultArray[0].accatid;
            this.catid=resultArray[0].accatid;
            this.getrecdetails('selhtop20','',resultArray[0].accatid);
           
        },
        error => console.log("Error :: " + error)
        )
  }

  masmot() {
    this.mservice.masmotransaction()
        .subscribe(
        resultArray => {
            console.log('getmot', resultArray);
            this.Modeot = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  

  getstudentsdata() {
    this.cservice.getstudents_clwise(this.objmisc.clid,this.objmisc.scid,this.objmisc.crid)
        .subscribe(
        resultArray => {
            console.log('bloodgp', resultArray);
            this.arrstudent = resultArray;
           this.objmisc.stuid= resultArray[0].stuid;
            //this.SelectReportDetails();
        },
        error => console.log("Error :: " + error)
        )
  }
  mascourse() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrcourse = resultArray;
            this.objmisc.crid=resultArray[0].crid;
            this.masclass();
            
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
           this.classsort = resultArray.sort((a, b) => {
              if (a.clid > b.clid) {
                return -1;
              }
            });
           this.objmisc.clid=resultArray[0].clid;
            this.massection();
            
            
           
        },
        error => console.log("Error :: " + error)
        )
  }


  opencoldialog(content,objdata) {
   
      this.objdet=objdata;
      this.objdet.recdt=this.aservice.getdatetoday();
      //this.submodel.parentsubid=0;
      this.objdet.mor='CASH';
      this.objdet.cqno='';
      this.objdet.cqdt=this.aservice.getdatetoday();
      this.objdet.bknm='';
      this.objdet.ifsc='';
      this.objdet.RecAmt=objdata.BalAmt;
      console.log('recamt1',this.objdet.RecAmt);
     
      
//this.getrecdetails(objdata);
console.log('recamt2',this.objdet.RecAmt);
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      
     size:'lg'
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.sections = resultArray;
            this.objmisc.scid=resultArray[0].scid;
            this.getstudentsdata();
           // this.masasshead();
        },
        error => console.log("Error :: " + error)
        )
  }

  applyvocherFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  
    if(filterValue.length>=3)
    {
      this.getrecdetails('serchvoch',filterValue,this.catid);
      
    
  }
  else 
  {
    this.getrecdetails('selhtop20','',this.catid);
  }
  
  }

  getrecdetails(oprtype,sertxt,accatid)
{
  debugger
 

   this.aservice.feevocherh(oprtype,sertxt,accatid)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    
    this.recdetails = resultArray;

   
    },
   error => {console.log("Error :: " + error);
  
  alert('error while fetching results');}
)

}

getacchead() {
   const acids=this.arrrechead.map(({ acid }) => acid);
  // console.log('aciss',acids);
  this.mservice.getacchead('Active')
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
         
           const vendorsInCountyIds = resultArray.filter(i => !acids.includes(i.acid))
          // //const vendorsInCountyIds = resultArray.filter(i => !obj2.includes(i.id));
          // console.log('vendorsInCountyIds',vendorsInCountyIds);
          this.arracchead = vendorsInCountyIds;

         
      },
      error => console.log("Error :: " + error)
      )
} 

getacchead1() {
 // const acids=this.arrrechead.map(({ acid }) => acid);
 // console.log('aciss',acids);
 this.mservice.getacchead('Active')
     .subscribe(
     resultArray => {
         console.log('getdashcounts', resultArray);
        
          //const vendorsInCountyIds = resultArray.filter(i => !acids.includes(i.acid))
         // //const vendorsInCountyIds = resultArray.filter(i => !obj2.includes(i.id));
         // console.log('vendorsInCountyIds',vendorsInCountyIds);
         this.arracchead = resultArray;

        
     },
     error => console.log("Error :: " + error)
     )
} 


getaccheadwithcat() {
  debugger;
  this.arritem=this.arracchead.filter(item => item.accatid==this.objmisc.accatid);
 } 



 onmemberselectEvent(item) {
  //alert('hi');
      console.log('item',item);
      //this.selmember=item;
    //  this.getissuedbookinfocnts(item.id);
    //  this.getissueddetails();
      // do something with selected item
    }

    getmemberdetails(sertxt) {
      this.cservice.searchstudents(sertxt)
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
              this.memberdetails = resultArray;
              
          },
          error => console.log("Error :: " + error)
          )
    }
   
    onmemberChangeSearch(sertxt) {
      debugger
      // fetch remote data from here
      // And reassign the 'data' which is binded to 'data' property.
      if(sertxt.query.length>=3) 
      {
      this.getmemberdetails(sertxt.query);
      }
    }

    gettotal()
    {
      debugger
 this.sum=this.arrvocdet.map((a:any) => a.feamt).reduce(function (a:any, b:any) {
      return a + b;
    });
    
  }

openmdldetmain(content,objdata,vhno) {
debugger
  this.objvhead=objdata;

  this.getvocherdet(vhno);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


openmdlmisc(content) {
  debugger

  
this.arrvocdet=[];
this.objmisc={};
this.objmisc.accatid='0';
this.sum=0;
this.selmember={};

this.objmisc={recdt:this.mservice.getdatetoday(),cqdt:'',cqno:'',bkrefno:'',bank:'',mot:this.Modeot[0].motid};
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  


openmdlpartpays(content,objdata,vhno) {

  console.log('objdata',objdata);
  this.objvhead=objdata;

  this.getfeerech(vhno);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


openmdlfeecol(content,objdata) {

  this.objfcol=objdata;
  this.objfcol.mot='1';
  this.objfcol.branch='';
  this.objfcol.bank='';
  this.objfcol.bkrefno='';
  this.objfcol.cqdt='';
  this.objfcol.cqno='0';
  this.objfcol.recdt=this.aservice.getdatetoday();
  this.objfcol.recamt=objdata.fetamt-objdata.retamt;

  //this.getvocherdet(vhno);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


openposentry(content,objdata) {

  this.objfcol=objdata;
  this.objfcol.mot='Unified Payments';
  this.objfcol.pgrefno='';
  this.objfcol.bkcdnm='';
  this.objfcol.bkrefno='';
  this.objfcol.ptrnsdate='';
  this.objfcol.orderno='';
  this.objfcol.cqno='0';

  this.objfcol.recdt=this.aservice.getdatetoday();
  this.objfcol.recamt="";

  //this.getvocherdet(vhno);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


  getvocherdet(vhno)
{
  debugger
  
   this.aservice.feevocherd('selvohd',vhno)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    
    this.arrrechead = resultArray;
    this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
   
    },
   error => console.log("Error :: " + error)
)
  }

  cancelrecipt(recid,vhno,tag)
{
  debugger
  if(confirm("Are you sure? you wan't to cancel receipt."))
  {
   this.aservice.cancelrec(recid)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
   alert(resultArray.message);
   if(tag=="col")
   {
    this.getfeecol();
   }
   else if(tag=="stu")
   {
this.getfeerech(vhno);
this.applyvocherFilter(this.sertxt);

   }
    
  
   
    },
   error => console.log("Error :: " + error)
)
  }
  }

  getfeerech(vhno)
{
  debugger
  
   this.aservice.feerech('selrech',vhno)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    
    this.arrfeerech = resultArray;
   // this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
   
    },
   error => console.log("Error :: " + error)
)
  }



  getdashoverview()
  {
    debugger
    
     this.aservice.dashoverview()
    
    //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      
      this.objinfo = resultArray.objinfo;
      this.arrcat = resultArray.arrcat;
      this.arrclasscat = resultArray.arrclasscat;
     // this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
     
      },
     error => console.log("Error :: " + error)
  )
    }


  getfeecol()
{
  debugger
  this.fmodel.oprtype='recdtwise';
  console.log('fmodel',this.fmodel);
   this.aservice.feecolrpt(this.fmodel)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    
    this.arrcol = resultArray;
    //this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
   
    },
   error => console.log("Error :: " + error)
)

}


exportatsumsubrpt()
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"export/expfeesumstu.php?clcd="+clcd+"&aycd="+aycd+"&clid="+this.objfsm.clid;
   console.log("url",url)
   window.open(url,'');

}


attsubsum() {
  //this.cmodel.oprtype='sum_subwise';
  //console.log('pstdat',this.cmodel);

  this.aservice.getfeesumstu(this.objfsm)
  .subscribe(resultArray => {
      console.log('ret-by-atd', resultArray);
      this.attdata = resultArray;
this.colums=Object.keys(resultArray[0]);
      //alert(resultArray.message);

  }, error =>
      alert('error in connection')
  );
}


getfeesum()
{
  debugger
  this.fmodel.oprtype='recdtwise';
  console.log('fmodel',this.fmodel1);
   this.aservice.feesum(this.fmodel1)
  
  //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
  .subscribe(
    
   resultArray =>{
    console.log('result',resultArray) ;
    
    this.arrfeesum = resultArray;
    //this.ttldfeamt=this.arrrechead.reduce((sum, item) => sum + parseInt(item.feamt), 0);
   
    },
   error => console.log("Error :: " + error)
)

}
exportcolrpt()
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"export/expfeecolrpt.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.fmodel.dtfrm+"&dtto="+this.fmodel.dtto+"&clid="+this.fmodel.clid+"&secid="+this.fmodel.secid+"&accatid="+this.fmodel.accatid;
   window.open(url,'');

}

expsummary()
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"export/expfeesum.php?clcd="+clcd+"&aycd="+aycd+"&clid="+this.fmodel1.clid+"&secid="+this.fmodel1.secid+"&accatid="+this.fmodel1.accatid+"&crid="+this.fmodel1.crid;
   window.open(url,'');

}

openmdldetacc(content,objdata,cmd) {
    
  this.oprtype1=cmd;
  this.objdetacc={}
  if(cmd=='insert')
  {
    this.getacchead();

    //this.objdetacc.acid='1';
    this.objdetacc.vdid='0';
    this.objdetacc.feamt='1';
    this.objdetacc.vhno=this.objvhead.vhno;
    this.objdetacc.oprtype='insert';
    this.objdetacc.vhstsd='Active';

  }

  else if(cmd=='update')
  {
    this.getacchead1();

    this.objdetacc=objdata;
    this.objdetacc.oprtype='update';
    this.objdetacc.vhstsd='Active';
  }
  //this.getacfeechartdetail(objdata);
  this.modalOptions1 = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
  }
  this.modalRef1=this.modalService.open(content,this.modalOptions1);
  
  this.modalRef1.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

saveaccvoucherd()
{

  

  
  //this.objdet.recdetails=JSON.stringify(this.objdetacc);
  
  //var recdata={RecAmt:f.value.RecAmt,bknm:f.value.bknm,cqdt:cdt,cqno:f.value.cqno,dbnm:f.value.dbnm,deptid:f.value.deptid,ifsc:f.value.ifsc,insid:f.value.insid,mor:f.value.mor,recdt:rdt,recno:f.value.recno,stuid:f.value.stuid,clcd:clcd,aycd:aycd};
  console.log('savedata',this.objdetacc);

  this.aservice.saveaccvoucherd(this.objdetacc)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      //this.alertmessage=result.message;
  //this.getreceipts();
  if(result.status=='success')
{
  
let localmodref=this.modalRef1;
localmodref.close();
this.getvocherdet(this.objvhead.vhno);
this.getrecdetails('selhtop20','',this.catid);

}
  
  }, error => 
  alert('error in connection')
  //this.alertmessage='error in connection'
  );

  
}

printpayack(stuid,recid,vhno,inid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"fpdf181/pdfreports/paymentacknowledge.php?clcd="+clcd+"&aycd="+aycd+"&stuid="+stuid+"&recid="+recid+"&vhno="+vhno+"&inid="+inid;
   window.open(url,'','_blank');

//http://43.247.158.94:8081/mycampuz/api/v3/fpdf181/pdfreports/payreceipt.php
   
 }

 printpayreceipt(stuid,recid,vhno,inid){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.aservice.callurl+"fpdf181/pdfreports/payreceipt.php?clcd="+clcd+"&aycd="+aycd+"&stuid="+stuid+"&recid="+recid+"&vhno="+vhno+"&inid="+inid;
   window.open(url,'','_blank');

//http://43.247.158.94:8081/mycampuz/api/v3/fpdf181/pdfreports/payreceipt.php
   
 }

deleteaccvoucherd(objdetacc)
{

  if(confirm("Are you sure, you want to delete?"))
  {
  objdetacc.oprtype='delete';

  
  
  console.log('del',objdetacc);

  this.aservice.saveaccvoucherd(objdetacc)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
   

this.getvocherdet(this.objvhead.vhno);
this.getrecdetails('selhtop20','',this.catid);


  
  }, error => 
  alert('error in connection')
  //this.alertmessage='error in connection'
  );
  }
  
}


savepos()
{

  console.log('savedata',this.objfcol);

  if(parseFloat(this.objfcol.recamt)>parseFloat(this.objfcol.fetamt))
  {
    alert("Receiept amount entered is greater then payable amount");
  }

  else{

  this.showload='Yes';
  console.log('savedata',this.objfcol);

  this.aservice.savepos(this.objfcol)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      this.showload='No';
      //this.alertmessage=result.message;
  //this.getreceipts();
  if(result.status=='success')
{
  
let localmodref=this.modalRef;
localmodref.close();
//this.getvocherdet(this.objvhead.vhno);
this.getrecdetails('selhtop20','',this.catid);

}
  
  }, error => 
  {
    this.showload='No';
  alert('error in connection');
  }
  //this.alertmessage='error in connection'
  );
  }
  
}


savefeecol()
{

  if(parseFloat(this.objfcol.recamt)>parseFloat(this.objfcol.fetamt))
  {
    alert("Receiept amount entered is greater then payable amount");
  }

  else{

  this.showload='Yes';
  console.log('savedata',this.objfcol);

  this.aservice.savefeecol(this.objfcol)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      this.showload='No';
      //this.alertmessage=result.message;
  //this.getreceipts();
  if(result.status=='success')
{
  
let localmodref=this.modalRef;
localmodref.close();
//this.getvocherdet(this.objvhead.vhno);
this.getrecdetails('selhtop20','',this.catid);

}
  
  }, error => 
  {
    this.showload='No';
  alert('error in connection');
  }
  //this.alertmessage='error in connection'
  );
  }
  
}


remaddacchead(ind)
{
//alert(ind);
this.arrvocdet.splice(ind,1);
}

addacchead()
{
  
  console.log('arrvoc',this.arrvocdet);
  this.getacchead1();
this.arrvocdet.push({acid:'1',feamt:'0'});
console.log('arrvoc1',this.arrvocdet);

}


savemiscreceipt()
{
debugger
 
 if (this.selmember.stuid == undefined || this.selmember.stuid == '')
  {

    alert ('Please select student');
  }
 
  else if (this.arrvocdet == undefined || this.arrvocdet.length == undefined || this.arrvocdet.length==0)
  {

    alert ('Please add particular(s)');
  }

  else if (this.objmisc.accatid == undefined  )
  {

    alert ('Please select category');
  }
  

  else{

var checknull=this.arrvocdet.some(item => item.feamt == '' );
var checknull1=this.arrvocdet.some(item => item.acid == '' || item.acid == null);
console.log('check',checknull);

if(checknull == false && checknull1 == false)
{

var pstdata={stuid:this.selmember.stuid,clid:this.selmember.clid,cqno:this.objmisc.cqno,cqdt:this.objmisc.cqdt,mot:this.objmisc.mot,bkrefno:this.objmisc.bkrefno,bank:this.objmisc.bank,recamt:this.sum,arrperticular:this.arrvocdet,recdt:this.objmisc.recdt,accatid:this.objmisc.accatid};

this.showload='Yes';
  console.log('savedata',pstdata);

  this.aservice.savemiscfee(pstdata)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      this.showload='No';
      //this.alertmessage=result.message;
  //this.getreceipts();
  if(result.status=='success')
{
  
let localmodref=this.modalRef;
localmodref.close();

this.arrvocdet=[];
this.objmisc={};
this.sum=0;
this.selmember={};
//this.getvocherdet(this.objvhead.vhno);


}
  
  }, error => 
  {
    this.showload='No';
  alert('error in saving');
  }
  //this.alertmessage='error in connection'
  );
}

else{

  alert('Please enter amount / select particular');
}
  }

 

}
  onclasschange()
  {

this.by_sp_student();
  }
  by_sp_student() {
    debugger
   var dbnm = '';
     var clid = this.fmodel.clid;
     var secid = this.fmodel.secid;
     var brid = '0';
     this.aservice.by_sp_student(clid, secid,brid)
      .subscribe(
      resultArray => {
        console.log('std-result', resultArray);
        this.arrstudent = resultArray;  
        this.fmodel.stuid=resultArray[0].stuid;
      },
      error => console.log("Error :: " + error)
      );
  }


  openstudent(content) {

     this.objstu={};
 
    //this.getvocherdet(vhno);
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef2=this.modalService.open(content,this.modalOptions);
    
    this.modalRef2.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  saveoldstutstudent()
{



  // this.showload='Yes';
  console.log('savedata',this.objstu);

  this.aservice.saveoldstutstudent(this.objstu)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      // this.showload='No';
      //this.alertmessage=result.message;
  //this.getreceipts();
  if(result.status=='success')
{
  
let localmodref=this.modalRef2;
localmodref.close();
//this.getvocherdet(this.objvhead.vhno);
// this.getrecdetails('selhtop20','',this.catid);

}
  
  }, error => 
  {
    // this.showload='No';
  alert('error in connection');
  }
  //this.alertmessage='error in connection'
  );
  
  
}

  
}
